import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <FadeIn data-id="element-72">
          <div className="bg-cream-50 rounded-3xl p-8 md:p-12 border-2 border-gold-300 shadow-lg relative overflow-hidden text-center" data-id="element-73">
            {/* Decorative background */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold-100 rounded-full filter blur-3xl opacity-50 -mr-20 -mt-20" data-id="element-74"></div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-75">
              <div className="w-20 h-20 bg-gold-100 rounded-full flex items-center justify-center mb-6 border border-gold-200 shadow-inner" data-id="element-76">
                <ShieldCheck className="w-10 h-10 text-gold-500" data-id="element-77" />
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-burgundy-900 mb-6" data-id="element-78">
                Tu inversión está 100% protegida
              </h2>

              <div className="space-y-4 text-lg text-burgundy-800 leading-relaxed" data-id="element-79">
                <p className="font-bold" data-id="element-80">
                  Tenés 7 días completos para explorar toda la colección.
                </p>
                <p data-id="element-81">
                  Si la abrís, la leés y sentís que no te aportó nada nuevo — te
                  devolvemos el 100% de tu dinero. Sin preguntas. Sin
                  formularios complicados. Sin drama.
                </p>
                <p className="italic text-burgundy-700" data-id="element-82">
                  Porque estamos tan seguras de lo que este sistema puede hacer
                  por vos y por tu hijo que preferimos asumir el riesgo
                  nosotras.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}